import LogInButton from '@/creditflowresearch/ui/common/components/LogInButton';
import {
  getProDescription,
  getUnauthorizedDescription,
} from '@/creditflowresearch/ui/common/components/organisms/constants';
import TileAccessFallback from '@/creditflowresearch/ui/common/components/organisms/TileAccessFallback';
import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import { useGetLinkToAllStats } from './useGetLinkToAllStats';

interface IStatsTileFallbackProps {
  isAuthorized?: boolean,
}

const TOOLTIP_CONTENT = 'Issuance statistics providing comprehensive market data and analytics for fixed income professionals.';

const StatsTileFallback = ({ isAuthorized = false }: IStatsTileFallbackProps) => {
  const link = useGetLinkToAllStats();

  if (isAuthorized) {
    return (
      <TileAccessFallback
        title="Stats"
        dataTest="statsTileAccessFallback"
        tooltipContent={ TOOLTIP_CONTENT }
        description={ getProDescription(link) }
        className={ spacesStyles.mtl }
      />
    );
  }

  return (
    <TileAccessFallback
      title="Stats"
      dataTest="statsTileAccessFallback"
      tooltipContent={ TOOLTIP_CONTENT }
      description={ getUnauthorizedDescription(link) }
      actionButton={ <LogInButton withIcon={ false } variant="outline" /> }
      className={ spacesStyles.mtl }
    />
  );
};

export default StatsTileFallback;
